export type DataLoadStatus = 'BeforeFirstLoad' | 'AfterFirstLoad' | 'LoadError';

export const DataLoadStatus = {
  BeforeFirstLoad: 'BeforeFirstLoad' as DataLoadStatus,
  AfterFirstLoad: 'AfterFirstLoad' as DataLoadStatus,
  LoadError: 'LoadError'as DataLoadStatus
};